import React, { useRef, useEffect } from "react";
import css from "./resume.module.css";

const SkillCard = ({ category, skills, icon, index }) => {
  const revealRef = useRef(null);

  useEffect(() => {
    const revealEl = revealRef.current;
    if (!revealEl) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    observer.observe(revealEl);
    return () => observer.disconnect();
  }, []);

  const delayClass = `reveal-delay-${Math.min(index + 1, 4)}`;

  return (
    <div ref={revealRef} className={`reveal ${delayClass}`}>
      <div className={css.skillCard}>
        <div className={css.skillIcon}>{icon}</div>
        <h3 className={css.skillCategory}>{category}</h3>
        <div className={css.skillTags}>
          {skills.map((skill) => <span key={skill} className={css.skillTag}>{skill}</span>)}
        </div>
      </div>
    </div>
  );
};

export default SkillCard;
